export const blogPosts = [
  {
    id: '1',
    slug: 'designing-first-impressions',
    title: 'Designing first impressions that convert',
    excerpt: 'Why the first seven seconds of a landing page decide whether a visitor stays, and how to design for them deliberately.',
    category: 'Product Design',
    author: 'Maya Ferrante',
    authorRole: 'Head of Design',
    publishedAt: '2026-06-02',
    readTime: '6 min read',
    cover: 'aurora',
    content: [
      { type: 'p', text: 'Visitors decide whether to keep reading before they consciously register a single word. That judgment is made from shape, contrast, and motion — the layer beneath copy.' },
      { type: 'h2', text: 'Start with the thesis, not the hero image' },
      { type: 'p', text: 'A hero section should state a single, specific claim about the product. Generic reassurance reads as filler, and visitors are unusually good at detecting filler.' },
      { type: 'p', text: 'Solvora treats the hero as an argument: one sentence, one supporting visual, one action. Everything else on the page exists to support that opening claim.' },
      { type: 'h2', text: 'Motion as punctuation' },
      { type: 'p', text: 'Animation should behave like punctuation in a sentence — present to clarify rhythm, never present for its own sake. A staggered reveal on scroll tells a visitor "these three things belong together." A hover state confirms "this is interactive." Beyond that, restraint reads as confidence.' },
    ],
  },
  {
    id: '2',
    slug: 'building-a-scalable-design-system',
    title: 'Building a design system that survives a rebrand',
    excerpt: 'Tokens, not components, are the real foundation. Here is how Solvora structures color, type, and spacing so a rebrand touches one file.',
    category: 'Design Systems',
    author: 'Devon Okafor',
    authorRole: 'Design Systems Lead',
    publishedAt: '2026-05-18',
    readTime: '8 min read',
    cover: 'grid',
    content: [
      { type: 'p', text: 'Most design systems fail at the first rebrand, because color and type are hard-coded into components instead of referenced from a single source of truth.' },
      { type: 'h2', text: 'Tokens first, components second' },
      { type: 'p', text: 'Every component in Solvora reads from a shared set of CSS custom properties. Swapping an accent color or a typeface is a one-line change, not a find-and-replace across dozens of files.' },
      { type: 'h2', text: 'Name things by role, not by value' },
      { type: 'p', text: 'A variable named --color-accent survives a rebrand. A variable named --color-purple does not. Naming by role keeps the system meaningful even after every value inside it changes.' },
    ],
  },
  {
    id: '3',
    slug: 'launching-with-a-waitlist',
    title: 'What actually moves people onto a waitlist',
    excerpt: 'A look at the handful of page elements that measurably affect waitlist sign-up rate — and the many that do not.',
    category: 'Growth',
    author: 'Priya Nandan',
    authorRole: 'Growth Lead',
    publishedAt: '2026-04-29',
    readTime: '5 min read',
    cover: 'pulse',
    content: [
      { type: 'p', text: 'Teams spend weeks debating headline copy and days on the actual form. That ratio is usually backwards.' },
      { type: 'h2', text: 'Reduce the form before you rewrite the headline' },
      { type: 'p', text: 'Every additional field on a sign-up form measurably reduces completion. Email alone will outperform email-plus-four-questions almost every time — ask the rest after someone has committed.' },
      { type: 'h2', text: 'Show the product, not a promise about the product' },
      { type: 'p', text: 'An interactive preview, even a limited one, consistently outperforms a paragraph describing what the product will eventually do.' },
    ],
  },
];
